import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Currency, CurrencyService } from "../../lh-core/services/currency.service";
import { Subject, takeUntil } from "rxjs";

@Component({
    selector: 'lh-currency-toggle',
    standalone: false,
    templateUrl: './currency-toggle.component.html',
    styleUrls: ['./currency-toggle.component.scss']
})
export class CurrencyToggleComponent implements OnInit, OnDestroy {
    constructor(private currencyService: CurrencyService) { }

    private destroyed$ = new Subject();

    @Input() defaultCurrency: Currency = 'USD'

    currency: Currency = this.defaultCurrency;

    ngOnInit() {
        this.currencyService.current$.pipe(
            takeUntil(this.destroyed$)
        ).subscribe(currency => {
            this.currency = currency;
        });        
    }

    onCurrencyChange(value: any) {
        this.currencyService.changeCurrency(value)
    }

    ngOnDestroy() {
        this.destroyed$.next(true);
    }
}